import React from 'react';
import './pod.css';

function Pod({ title, children }) {
    return (
        <div className="pod">
            <h3><span className="tag"></span>{title}</h3>
            <div>{children}</div>
        </div>
    );
}

export default Pod;
